/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import IPisos from 'Infotrack@Modelos/smartStock/pisos/entidades/pisos';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { AnyAction } from 'redux';

export interface IEstadoPisos {
    estadoFormulario: boolean;
    entidadPisos: IPisos | null;
    recargarTabla: boolean;
    tipoFormulario: TipoFormulario;
}

export const estadoIncial: IEstadoPisos = {
    entidadPisos: null,
    estadoFormulario: false,
    recargarTabla: false,
    tipoFormulario: TipoFormulario.Creacion,
};

export enum acciones {
    CAMBIAR_ESTADO_FORMULARIO = 'CAMBIAR_ESTADO_FORMULARIO',
    RECARGAR_TABLA = 'RECARGAR_TABLA',
}

export const reductor = (estado: IEstadoPisos, { type, payload }: AnyAction) => {
    switch (type) {
        case 'CAMBIAR_ESTADO_FORMULARIO': {
            return {
                ...estado,
                entidadPisos: payload ? payload.entidadPisos : null,
                estadoFormulario: !estado.estadoFormulario,
                tipoFormulario: payload ? payload.tipoFormulario : estado.tipoFormulario,
            };
        }
        case 'RECARGAR_TABLA':
            return {
                ...estado,
                recargarTabla: !estado.recargarTabla,
            };
        default:
            return estado;
    }
};
